export const getPurchaseItemLocation = (path: string, itemId?: string) => {
  const resAr = path.split('/').slice(0, -1);
  if (itemId) resAr.push(itemId);

  return resAr.join('/');
};
